import { Collapse as MuiCollapse, CollapseProps as MuiCollapseProps, styled } from "@mui/material";

const StyledCollapse = styled(MuiCollapse)(() => ({
  // ... existing styles
}));

interface CollapseProps extends MuiCollapseProps {
  children: React.ReactNode;
}

export const Collapse: React.FC<CollapseProps> = ({ children, ...props }) => {
  return <StyledCollapse {...props}> {children}</StyledCollapse>;
};

export default Collapse;
